import "./CookiePolicy.module.css";
import Header from "@/reusable_sections/Header";
import DentalGuide from "./sections/DentalGuide";
import CookiePolicyDetails from "./sections/CookiePolicyDetails";
import CookieManagement from "./sections/CookieManagement";
import Transparency from "./sections/Transparency";
import Footer from "@/reusable_sections/Footer";
export default function CookiePolicyPage() {
  return <div>
      <Header />
      <DentalGuide />
      <CookiePolicyDetails />
      <CookieManagement />
      <Transparency />
      <Footer />
    </div>;
}